exports.data = [
	{
		tab: "B.Tech.",
		role: "B.Tech.",
		institute: "NIT Allahabad",
		instituteLink: "http://www.mnnit.ac.in",
		date: "Nov 2020 - Pursuing",
		description: [
			"Pursuing B.Tech. in Information Technology",
			"CPI - 9.46 out of 10",
		],
	},

	{
		tab: "Senior Secondary",
		role: "Senior Secondary",
		institute: "Vijay Memorial Sr. Sec. School Indora",
		date: "April 2018 - April 2020",
		description: [
			"Completed Senior Secondary in PCM subject",
			"Got 94.8 percentage",
		],
	},

	{
		tab: "Secondary",
		role: "Secondary",
		institute: "Vijay Memorial Sr. Sec. School Indora",
		date: "April 2016 - April 2018",
		description: [
			"Completed Secondry Education",
			"Got 93.8 percentage",
		],
	},
];
